import axios from 'axios';
import React, { useState } from 'react';
export default function withAxiosAuthorizationHeaderUpdater(Provider) {
    return function ReactKeycloakProvider(props) {
        const { authClient, onTokens, axios: axiosPromise = axios, ...other } = props;
        const [initialized, setInitialized] = useState(false);
        return (React.createElement(Provider, { authClient: authClient, onTokens: async (tokens) => {
                const axios = await axiosPromise;
                const { token } = tokens;
                if (token) {
                    axios.defaults.headers.common.Authorization = `Bearer ${token}`;
                }
                else {
                    delete axios.defaults.headers.common.Authorization;
                }
                await (onTokens === null || onTokens === void 0 ? void 0 : onTokens(tokens));
                setInitialized(true);
            }, ...other }, initialized && other.children));
    };
}
//# sourceMappingURL=withAxiosAuthorizationHeaderUpdater.js.map